import { SubProductCharacteristic } from './subProductCharacteristic.model';
import {Post} from "./post.model";
import { Product } from './product.model';
export interface ISubProduct{
  id?: number;
  product?: Product;
  productId ?: string;
  productID ?: string;
  name?: string;
  subProductID?: string;
  photo?: string;
  photo1?: string;
  photo2?: string;
  subProductCharacteristics?: SubProductCharacteristic[];
  quantity?: number;
  price?: number;
  threshold?: number;
  photoTampon?: string;
  createdAt?: Date;
  posts?: Post[];
  idshop?: string;
  shopName?: string;
}
export class SubProduct implements ISubProduct{
  constructor(
    public id?: number,
    public product?: Product,
    public productId ?: string,
    public productID ?: string,
    public name?: string,
    public subProductID?: string,
    public photo?: string,
    public photo1?: string,
    public photo2?: string,
    public subProductCharacteristics?: SubProductCharacteristic[],
    public quantity?: number,
    public price?: number,
    public threshold?: number,
    public photoTampon?: string,
    public createdAt?: Date,
    public posts?: Post[],
    public idshop?: string,
    public shopName?: string,
  ){
    this.id = id;
    this.product = product;
    this.productId = productId;
    this.productID = productID;
    this.name = name;
    this.subProductID = subProductID;
    this.photo = photo;
    this.photo1 = photo1;
    this.photo2 = photo2;
    this.subProductCharacteristics = subProductCharacteristics;
    this.quantity = quantity;
    this.price = price;
    this.threshold = threshold;
    this.photoTampon = photoTampon;
    this.createdAt = createdAt;
    this.posts = posts;
    this.idshop = idshop;
    this.shopName = shopName;
  }
}
